export default theme => ({
  wrapper: {
    // padding: '10px 0 10px 0',
    paddingBottom: theme.spacing.unit
  },
  item: {
    background: '#ccc',
    position: 'relative',
    // margin: '0 10px',
    backgroundPosition: '50% 50%',
    backgroundSize: 'cover',
    border: '2px solid #4a0000',
    '-moz-transition': 'border-color .3s',
    '-o-transition': 'border-color .3s',
    '-webkit-transition': 'border-color .3s',
    transition: 'border-color .3s',

    '&:hover': {
      borderColor: '#fc4a38',
    },
    '&:hover .featured-videos-icon': {
      color: '#fc4a38',
    }
  },
  list: {
    borderRight: '1px solid #444',
  },
  itemContainer: {
    position: 'absolute',
    bottom: 0, left: 0, right: 0, top: 0,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    alignContent: 'center',
    justifyContent: 'center',
  },
  container: {
    backgroundColor: '#3f290c',
    padding: 10,
    display: 'flex',
  },
  thumbnail: {
    display: 'block',
    // [theme.breakpoints.down("xs")]: {
    //   height: 175,
    // },
    // [theme.breakpoints.up("sm")]: {
    //   height: 140,
    // },
    // [theme.breakpoints.up("md")]: {
    //   height: 120,
    // },
  },
  icon: {
    fontSize: 24,
    color: '#fff',
    textShadow: '0 0 1px #444',
    '-moz-transition': 'color .3s',
    '-o-transition': 'color .3s',
    '-webkit-transition': 'color .3s',
    transition: 'color .3s'
  },
  link: {
    display: 'block',
  },
  content: {
    position: 'absolute',
    fontSize: '11px',
    bottom: 0,
    left: 0,
    right: 0,
    // top: 0,  
    padding: 5,
    color: '#fff',
    background: 'rgba(0,0,0,0.6)',
    wordBreak: 'break-word',
    maxHeight: '100%',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  }
});